export default __webpack_public_path__ + "static/media/housefires-iii.dfc60ac1.jpg";